import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import type { DateValidationError, PickerChangeHandlerContext } from '@mui/x-date-pickers';

interface DatePickerProps extends Omit<React.ComponentProps<typeof DatePicker>, 'value' | 'onChange'> {
    value?: any;
    onChange?: (value: any, context?: PickerChangeHandlerContext<DateValidationError>) => void;
    fullWidth?: boolean;
}

const getDefaultSlotProps = (fullWidth: boolean) => ({
  textField: {
    size: "small" as const,
    fullWidth,
    InputLabelProps: {
      shrink: true,
    },
    sx: {
      "& .MuiInputLabel-root": {
        color: "#2498f3 !important",
      },
      "& .MuiInputLabel-root.Mui-focused": {
        color: "#2498f3 !important",
      },
      "& .MuiFormLabel-root": {
        color: "#2498f3 !important",
      },
      "& .MuiFormLabel-root.Mui-focused": {
        color: "#2498f3 !important",
      },
      "& .MuiOutlinedInput-notchedOutline": {
        borderColor: "#2498f3",
      },
      "&:hover .MuiOutlinedInput-notchedOutline": {
        borderColor: "#2498f3",
      },
      "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
        borderColor: "#2498f3",
      },
    },
  },
});

export const ByzMuiDatePicker = (props: DatePickerProps) => {
  const { fullWidth = false, ...restProps } = props;
  
  // Merge default slotProps with user-provided slotProps
  const defaultSlotProps = getDefaultSlotProps(fullWidth);
  const userSlotProps = props.slotProps || {};
  const userTextField = (userSlotProps.textField as any) || {};
  const isDisabled = props.disabled || false;
  
  const disabledStyles = isDisabled ? {
    "& .MuiInputLabel-root.Mui-disabled": {
      color: "rgba(0, 0, 0, 0.38) !important",
    },
    "& .MuiFormLabel-root.Mui-disabled": {
      color: "rgba(0, 0, 0, 0.38) !important",
    },
    "& .MuiOutlinedInput-root.Mui-disabled .MuiOutlinedInput-notchedOutline": {
      borderColor: "rgba(0, 0, 0, 0.26) !important",
    },
    "&:hover .MuiOutlinedInput-root.Mui-disabled .MuiOutlinedInput-notchedOutline": {
      borderColor: "rgba(0, 0, 0, 0.26) !important",
    },
  } : {};
  
  const mergedSlotProps = {
    ...defaultSlotProps,
    ...userSlotProps,
    textField: {
      ...defaultSlotProps.textField,
      ...userTextField,
      InputLabelProps: {
        ...defaultSlotProps.textField.InputLabelProps,
        ...(userTextField.InputLabelProps || {}),
        disabled: isDisabled,
      },
      sx: {
        ...defaultSlotProps.textField.sx,
        ...disabledStyles,
        ...(userTextField.sx || {}),
      },
    },
  };

  return (
    <DatePicker
      {...restProps}
      slotProps={mergedSlotProps}
    />
  );
};